import moment from 'moment';
import React from 'react';
import { Disabled, Enabled } from '../Icons/Icons';
import { dateFormatter as date, labelFormatter as label } from '../Utils/Formatter';


export const dateFormatter = (cell) => {
  return date(cell, 'DD/MM/YYYY');
}

export const dateMMMFormatter = (cell) => {
  return date(cell, 'DD/MMM/YYYY');
}

export const dateTimeFormatter = (cell) => {
  return (<div className="table-date"> {moment(cell).format('DD/MM/YYYY HH:mm')} </div>);
}

export const labelFormatter = (cell) => {
  return label(cell);
}

export const statusFormatter = (cell) => {

  if (cell)
    return (<div className="btn-table-actions"><Enabled className="status-active" /></div>);

  return (<div className="btn-table-actions"><Disabled className="status-inactive" /></div>);
}

export const customDateTimeFormatter = (dateTime) => {
  if (!dateTime)
    return "";

  return (<>{moment(dateTime).format('DD/MM/YYYY HH:mm')} </>);
}

export const customDateTimeFormatterString = (dateTime) => {
  if (!dateTime)
    return "";

  return (moment(dateTime).format('DD/MM/YYYY HH:mm'));
}
